// extracted by mini-css-extract-plugin
export default {"btn-back":"fXzr2IfblHiWJG2zeqkY","disabled":"J12B49tpJBpch2aNbqeW"};